import axios from "../config/interceptor";

/**
 * POST /email/payment-receipt via the Next.js legacy proxy.
 *
 * Sends a Bukti Pembayaran email to the patient for a completed reservation.
 * Behind the ENABLE_EMAIL_RECEIPT server flag — a 404 means the feature is
 * disabled in the current environment and the UI should stay hidden.
 *
 * The server always persists the recipient email to the patient profile on
 * successful send (assuming it differs from the stored value). There is no
 * client-side opt-in flag.
 *
 * @param {Object} params
 * @param {number|string} params.reservationId  Booking / reservation id.
 * @param {string} [params.email]               Override recipient. If omitted
 *                                              the server uses patient.email.
 * @returns {Promise<{ok: boolean, status: number, data: any, error?: string}>}
 */
export const sendPaymentReceiptEmail = async ({ reservationId, email }) => {
  if (!reservationId) {
    return { ok: false, status: 0, data: null, error: "reservationId required" };
  }

  try {
    const body = { reservationId };
    if (email) body.email = email;

    const response = await axios.post("/email/payment-receipt", body);
    return {
      ok: true,
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    const status = err?.response?.status ?? 0;
    const data = err?.response?.data ?? null;
    return {
      ok: false,
      status,
      data,
      error: data?.error || err?.message || "unknown_error",
    };
  }
};
